// The browser's Save-as-PDF dialog proposes document.title as the file name;
// keep the exact name the old html-to-pdf service download used.
export default function exportFilename(trip) {
  const slug = trip?.name?.replace(/\s+/g, '-')?.toLowerCase();
  return ['travelogue', trip?.id, slug].filter(Boolean).join('-');
}
